export default {
  cbam_news: "CBAM 新聞",
  view_all_news: "查看所有新聞",
  search_news: "搜尋新聞...",
  no_news: "暫無新聞",
  fetch_news_failed: "獲取新聞失敗",
};
